<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <div class="btn-group w-100 mb-3" role="group">
                   <button type="button" class="btn btn-secondary" @click="nav = 1" :class="{'active': nav == 1}" :disabled="nav == 1">
                        <span>Manual</span>
                   </button>
                   <button type="button" class="btn btn-secondary" @click="nav = 2" :class="{'active': nav == 2}" :disabled="nav == 2">
                        <span>Automático</span>
                   </button>
               </div><!-- /btn-group -->
                <template v-if="nav == 1">
                    <form @submit.prevent="addLeague">
                        <div class="form-group">
                            <label class="text-white" for="liga">Liga</label>
                            <input type="text" class="form-control" id="liga" v-model="liga" :readonly="block" autocomplete="off" spellcheck="false" required>
                        </div>
                        <div class="form-group">
                            <label class="text-white" for="liga-id">ID da liga</label>
                            <input type="text" class="form-control" id="liga-id" v-model="liga_id" :readonly="block" autocomplete="off" spellcheck="false" required>
                        </div>
                        <div class="form-group">
                            <label class="text-white" for="destacar">Destacar liga</label>
                            <select class="form-control" id="destacar" v-model="destacar">
                                <option value="1" :selected="destacar == '1'">Sim</option>
                                <option value="2" :selected="destacar == '2'">Não</option>
                            </select>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button type="submit" class="btn btn-block btn-success" :disabled="block">
                                    <i class="fas fa-save mr-2"></i>Salvar
                                </button>
                            </div>
                            <div class="col">
                                <a class="btn btn-block btn-danger" @click="cancel" :class="{'disabled': block}">
                                    <i class="fas fa-ban mr-2"></i>Cancelar
                                </a>
                            </div>
                        </div>
                    </form>
                </template>
                <template v-else>
                    <select class="form-control" v-model="liga_id">
                        <option :value="item.league.id" v-for="(item, index) in eventos" :key="index" :selected="liga_id == item.league.id">
                            {{item.league.name}}
                        </option>
                    </select>
                </template>
            </div>
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            nav: 1,
            liga: '',
            liga_id: '',
            destacar: '2',
            eventos: [],
            block: true,
            loading: false,
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading
    },
    methods: {
        addLeague() {

            const self = this;
            
            if (self.liga.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o nome da liga!',
                    'warning'
                );
            } else if (self.liga_id.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o ID da liga!',
                    'warning'
                );
            } else {

                self.loading = true;

                api.post('insere-liga', {
                    liga: self.liga,
                    liga_id: self.liga_id,
                    destacar: self.destacar
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            self.leagueDialog(response.data.id);
                        break;
                        default:
                            Swal.fire(
                                'Atenção!',
                                response.data.message,
                                'warning'
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        cancel() {
            this.liga = '';
            this.liga_id = '';
        },
        leagueDialog(id) {

            const self = this;

            Swal.fire({
                title: 'Parabéns, liga inserida!',
                html: 'Você deseja adicionar essa liga nos sistemas?',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.post('up-clientes', {
                        id: id,
                        liga: self.liga,
                        destacar: self.destacar
                    }).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                self.liga = '';
                                self.liga_id = '';
                                Swal.fire(
                                    'Parabéns!',
                                    'As ligas foram inseridas com sucesso!',
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção!',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            });
        }
    },
    watch: {
        liga(value) {
            this.liga = value.replace(/[^a-zà-ú0-9-\s]+/gi,'');
        },
        liga_id(value) {
            this.liga_id = value.replace(/[^a-zA-Z0-9-]+/gi,'');

            if (value) {
                this.liga = this.eventos.find((item) => item.league.id == value).league.name;
            }
        },
        nav(value) {
            
            if (value == 2 && this.eventos.length == 0) {

                this.loading = true;

                api.get('get-leagues').then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            this.eventos = response.data.events.eventos.reduce((unique, o) => {
                                if(!unique.some(obj => obj.league.id === o.league.id)) {
                                    unique.push(o);
                                }
                                return unique;
                            },[]).sort((a, b) => {
                                return a.league.name.localeCompare(b.league.name)
                            });
                        break;
                        default:
                            Swal.fire(
                                'Atenção!',
                                response.data.message,
                                'warning'
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            this.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            this.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
}
</script>